export default "__VITE_ASSET__8c811809__"